import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

export const SPECIAL_CHARS_REGEX = /[@#$%^&+=]+/;
export const NUMBER_REGEX = /[0-9]+/;
export const LOWERCASE_REGEX = /[a-z]+/;
export const UPPERCASE_REGEX = /[A-Z]+/;

export const PasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors => {

  const value: string = control.value ? control.value : '';

  if (!value) {
    return {};
  }

  if (value.length < 9) {
    return { 'lengthMatch': true };
  }

  if (!SPECIAL_CHARS_REGEX.test(value)) {
    return { 'specialCharsMatch': true };
  }

  if (!NUMBER_REGEX.test(value)) {
    return { 'numberMatch': true };
  }

  if (!LOWERCASE_REGEX.test(value)) {
    return { 'lowerCaseMatch': true };
  }

  if (!UPPERCASE_REGEX.test(value)) {
    return { 'upperCaseMatch': true };
  }

  return {};
};

export const Ga3PasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value: string = control.value ? control.value : '';

  if (!value) {
    return null;
  }

  const errors: ValidationErrors = {};

  if (value.length < 12) {
    errors['ga3MinLength'] = true;
  }

  if (value.length > 64) {
    errors['ga3MaxLength'] = true;
  }

  if (/\s/.test(value)) {
    errors['ga3Whitespace'] = true;
  }

  if (/(.)\1{2}/.test(value)) {
    errors['ga3RepeatedCharacters'] = true;
  }

  if (!/[a-z]/.test(value)) {
    errors['ga3LowercaseMatch'] = true;
  }

  if (!/[A-Z]/.test(value)) {
    errors['ga3UppercaseMatch'] = true;
  }

  if (!/[0-9]/.test(value)) {
    errors['ga3NumberMatch'] = true;
  }

  if (!/[^A-Za-z0-9\s]/.test(value)) {
    errors['ga3SpecialCharactersMatch'] = true;
  }

  return Object.keys(errors).length ? errors : null;
};
